/*
 * @Author: your name
 * @Date: 2021-03-24 18:39:43
 * @LastEditTime: 2021-06-19 20:58:27
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Tutor.Web\src\utils\microSeviceFormatRequest.js
 */
import request from './request'
import main from '@/main'
import {
  setToken
} from '@/utils/auth'
import sendError from './sendError'

// 针对微服务格式的返回值进行进一步封装
// 如有必要可替换为新的axios service
export default async function (config) {
  const res = await request(config)
  if (res.data.ErrorCode === 0) {
    return res.data.Body
  } else if (res.data.ErrorCode === 3) {
    setToken('')
    window.location.href = '/login'
  } else if (res.data.ErrorCode === 8) { // 当签名验证失败时打印错误
    console.log('errorcode：8, 签名验证失败')
  }
  // 错误消息弹出提示
  const chineseMsg = ['数据验证失败', '程序访问异常,请稍后重试！']
  const enMsg = ['Data verification failed', 'Program access is abnormal, please try again later!']
  let curMsg = res.data.Msg
  if (/.*[\u4e00-\u9fa5]+.*/.test(curMsg)) {
    switch (curMsg) {
      case chineseMsg[0]:
        sendError(enMsg[0])
        break
      case chineseMsg[1]:
        sendError(enMsg[1])
        break
      default:
        sendError(curMsg)
    }
  } else {
    if (curMsg !== 'Signature verification failed!') { // 特殊处理 去掉签名验证错误提示
      sendError(curMsg)
    }
  }
  return Promise.reject(curMsg)
}

export const request2 = async function (config) {
  const res = await request(config)
  if (res.data.ErrorCode === 0) {
    return res.data.Body
  } else if (res.data.ErrorCode === 3) {
    setToken('')
    window.location.href = '/login'
  } else if (res.data.ErrorCode === 8) { // 当签名验证失败时打印错误
    console.log('errorcode：8, 签名验证失败')
  }
  // 错误消息弹出提示
  const chineseMsg = ['数据验证失败', '程序访问异常,请稍后重试！']
  const enMsg = ['Data verification failed', 'Program access is abnormal, please try again later!']
  let curMsg = res.data.Msg
  if (/.*[\u4e00-\u9fa5]+.*/.test(curMsg)) {
    switch (curMsg) {
      case chineseMsg[0]:
        sendError(enMsg[0])
        break
      case chineseMsg[1]:
        sendError(enMsg[1])
        break
      default:
        sendError(curMsg)
    }
  } else {
    if (curMsg !== 'Signature verification failed!') { // 特殊处理 去掉签名验证错误提示
      sendError(curMsg)
    }
  }
  throw new Error(curMsg)
}

